export default (sort) => ({
    sort,
    allImages: [],

    renderedImages($event) {
        this.allImages = $event.detail.images;
    },

    deleteImages() {
        let selectedImages = [];

        if(this.allSelected) {
            this.allDeleted  = true;
            const images = _.isEmpty(this.selectedImages)
                ? this.selectedImages
                : this.images;

            selectedImages = images.map((image) => {
                image.deleted_at = true;

                return image.id;
            });
        } else {
            this.allDeleted  = false;
            selectedImages = this.selectedImages.map((image) => {
                image.deleted_at = true;

                return image.id;
            });
        }

        this.$wire.deleteImages(
            this.allSelected
                ? this.unselectedImages?.map((image) => image.id)
                : selectedImages,
            this.allSelected,
            this.idsToIgnore
        );

        this.idsToIgnore    = [];
        this.selectedImages = [];
        this.allSelected    = false;

        this.refreshVirtualScroll({}, 'quality-control::refresh');
    },

    restoreImages() {
        let selectedImages = [];

        if(this.allSelected) {
            selectedImages =  this.images.map((image) => {
                image.deleted_at = false;

                return image.id;
            });
        } else {
            selectedImages = this.selectedImages.map((image) => {
                image.deleted_at = false;

                return image.id;
            });
        }

        this.$wire.restoreImages(
            this.allSelected
                ? this.unselectedImages?.map((image) => image.id)
                : selectedImages,
            this.allSelected,
            this.idsToIgnore
        );

        this.idsToIgnore    = [];
        this.selectedImages = [];
        this.allSelected    = false;
        this.allDeleted     = false;

        this.refreshVirtualScroll({}, 'quality-control::refresh');
    },

    getImageCode(image) {
        if (!image.name) {
            return 'loading...';
        }
        
        const imageName = image.name?.split('_').pop().split('.')[0];
        const imageCode =  `${image.event_code}_${imageName}` ;
    
        return imageCode ?? 'loading...';
    },

    sorted({ detail }) {
        this.sort = detail;

        this.$dispatch('quality-control::restart', {
            params: {sort: this.sort}
        });
    },

    sortImages(grouped) {
        const images = Object.entries(grouped);

        return Object.fromEntries(
            _.orderBy( images )
        )
    }
})
